import { Component, Input } from '@angular/core';
import { PropertySummaryVM } from '../../../models/property-detail.vm';

/** Strip "Detalles de la propiedad": superficie / habitaciones / baños. Presentacional. */
@Component({
    selector: 'app-property-summary',
    templateUrl: './property-summary.component.html',
    styleUrls: ['./property-summary.component.scss'],
})
export class PropertySummaryComponent {
    @Input() summary: PropertySummaryVM | null = null;
}
